import { render, staticRenderFns } from "./InsCatLayout2.vue?vue&type=template&id=5da3e6d8&scoped=true"
import script from "./InsCatLayout2.vue?vue&type=script&lang=ts"
export * from "./InsCatLayout2.vue?vue&type=script&lang=ts"
import style0 from "./InsCatLayout2.vue?vue&type=style&index=0&id=5da3e6d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da3e6d8",
  null
  
)

export default component.exports